import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Avatar, Card, Progress, Typography } from "antd";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../useAuth";
import { getAvatarPath, isCaregiver } from "../../utils/userUtil";
import { useProfileProgress } from "../../hooks/useProfileProgress";
import "./ProfileStatus.css";
import { useCareType } from "../../hooks/useUserDisplay";

const ProfileStatus = () => {
  const { user } = useContext(AuthContext);
  const avatarPath = getAvatarPath(user);
  const progress = useProfileProgress(user);

  const navigate = useNavigate();

  return (
    <Card
      className="profile-status"
      actions={[]}
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            // flexDirection: "column",
          }}
        >
          <div
            style={{
              textAlign: "center",
            }}
          >
            <Avatar
              src={avatarPath}
              icon={<FontAwesomeIcon icon={faUser} />}
              size={75}
              shape="square"
            />
            <UserDisplay user={user} />
          </div>
        </div>
      }
    >
      <Typography.Text strong>Profile Completeness:</Typography.Text>
      <Progress percent={progress.percentage} strokeColor="#9D79BC" />
      <Button key="profile" block onClick={() => navigate("/profile")}>
        View Profile
      </Button>
    </Card>
  );
};

const UserDisplay = ({ user }) => {
  const careType = useCareType(user?.CareType);
  return (
    <>
      <Typography.Title level={4} style={{ marginBottom: 0, color: "#9D79BC" }}>
        {user?.FirstName} {user?.LastName}
      </Typography.Title>
      {isCaregiver(user) && (
        <Typography.Title type="secondary" level={5} style={{ marginTop: 0 }}>
          {careType}
        </Typography.Title>
      )}
    </>
  );
};

export default ProfileStatus;
